import ModelVersionViewModel from "@/domain/modelversion/ModelVersionViewModel";
import ClientBase from "../ClientBase";

class ModelVersionClient extends ClientBase {

    async getCurrentModelVersionByAssetId(assetId) {
        const data = await this.get(`api/v1/modelversions/assets/${assetId}/current`);
        return data ? new ModelVersionViewModel(data) : null;
    }

    async getModelVersionsByAssetId(assetId) {
        const data = await this.get(`api/v1/modelversions/assets/${assetId}`);
        return data?.map(version => new ModelVersionViewModel(version)) ?? [];
    }

    async createNewModelVersion(request) {
        const data = await this.post(`api/v1/modelversions`, request);
        return data ? new ModelVersionViewModel(data) : null;
    }

    async updateModelVersion(request) {
        const data = await this.put(`api/v1/modelversions/${request.assetId}/${request.id}`, request);
        return data ? new ModelVersionViewModel(data) : null;
    }

    async updateModelVersionScans(request) {
        const data = await this.put(`api/v1/modelversions/${request.assetId}/${request.id}/scans`, request);
        return data ? new ModelVersionViewModel(data) : null;
    }

    async publishModelVersion(orgId, assetId, versionId) {
        const data = await this.post(`api/v1/modelversions/organizations/${orgId}/assets/${assetId}/${versionId}/publish`, {});
        return data ? new ModelVersionViewModel(data) : null;
    }

    async setCurrentModelVersion(assetId, versionId) {
        const data = await this.put(`api/v1/modelversions/assets/${assetId}/current/${versionId}`, {});
        return data ? new ModelVersionViewModel(data) : null;
    }

    async deleteModelVersion(assetId, versionId, softDelete = true) {
        return await this.delete(`api/v1/modelversions/${assetId}/${versionId}`, { softDelete });
    }
}

export default new ModelVersionClient();